import React, { useEffect } from 'react';
import { CircularProgress, Grid, Typography } from "@material-ui/core";

import { SubscriptionService } from '../../../services/SubscriptionService';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from '../../../routes';
import { HorizontalCentered } from '../../../components/HorizontalCentered';
import { VerticalCenter } from '../../../components/VerticalCenter';


export function MakerCheckOutDialog(){
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        async function createBundleCheckout(){
            const response = await SubscriptionService.createBundleCheckoutSession({cancelPath: history.createHref(location) });

            if(response.success){
                history.push(routes.app.resolve.checkoutPage(response.data.sessionId))
            }
        };

        createBundleCheckout();
    }, []);

    return (
        <Grid container style={{height: 150, width: 150}}>
        <VerticalCenter>
            <HorizontalCentered>
                <CircularProgress />
            </HorizontalCentered>
            <Typography align="center" >Loading...</Typography>
        </VerticalCenter>
    </Grid>
    )
}